// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__m5D8d","sm":"Logo_sm__gZBbT","md":"Logo_md__B0ItI","lg":"Logo_lg__vvK3M"};